document.addEventListener('DOMContentLoaded', function () {
  var mq = window.matchMedia('(max-width: 749px)');

  document.querySelectorAll('ul.blog__posts[id*="featured_blog"]').forEach(function (list) {
    var originalItems = Array.from(list.children);
    var N = originalItems.length;
    var index = N;
    var baseOffset = 0;
    var cardWidth = 0;
    var autoTimer = null;

    var dragging = false;
    var startX = 0, startY = 0, lastX = 0, lastT = 0, velocity = 0;
    var dragStartTransform = 0;
    var directionLocked = null;

    function currentTranslateX(i) {
      var card = list.children[i];
      return -(card.offsetLeft - baseOffset);
    }

    function slideTo(i, animate, duration) {
      var x = currentTranslateX(i);
      if (animate === false) {
        list.style.transition = 'none';
        list.style.transform = 'translateX(' + x + 'px)';
        void list.offsetWidth;
      } else {
        list.style.transition = 'transform ' + (duration || 1) + 's cubic-bezier(0.65, 0, 0.35, 1)';
        void list.offsetWidth;
        list.style.transform = 'translateX(' + x + 'px)';
      }
    }

    function recenterIfNeeded() {
      if (index >= 2 * N) {
        index -= N;
        slideTo(index, false);
      } else if (index < N) {
        index += N;
        slideTo(index, false);
      }
    }

    function goTo(newIndex, duration) {
      index = newIndex;
      slideTo(index, true, duration);
      setTimeout(recenterIfNeeded, (duration || 1) * 1000 + 20);
    }

    function goNext() { goTo(index + 1, 1); }   // 自動送り: 1秒
    function goPrev() { goTo(index - 1, 1); }

    function startAutoplay() {
      stopAutoplay();
      autoTimer = setInterval(goNext, 3000);
    }
    function stopAutoplay() {
      if (autoTimer) clearInterval(autoTimer);
      autoTimer = null;
    }

    function addSwipeHandlers() {
      list.addEventListener('touchstart', function (e) {
        dragging = true;
        stopAutoplay();
        list.style.transition = 'none';

        startX = lastX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        lastT = Date.now();
        velocity = 0;
        directionLocked = null;
        dragStartTransform = currentTranslateX(index);
      }, { passive: true });

      list.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var x = e.touches[0].clientX;
        var y = e.touches[0].clientY;

        if (directionLocked === null) {
          var dx = Math.abs(x - startX);
          var dy = Math.abs(y - startY);
          if (dx > 6 || dy > 6) {
            directionLocked = dx > dy ? 'horizontal' : 'vertical';
          }
        }

        if (directionLocked === 'horizontal') {
          e.preventDefault();
        } else if (directionLocked === 'vertical') {
          dragging = false;
          list.style.transform = 'translateX(' + dragStartTransform + 'px)';
          startAutoplay();
          return;
        }

        var now = Date.now();
        var dt = now - lastT;
        if (dt > 0) velocity = (x - lastX) / dt;
        lastX = x;
        lastT = now;

        var delta = x - startX;
        list.style.transform = 'translateX(' + (dragStartTransform + delta) + 'px)';
      }, { passive: false });

      list.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;

        var delta = lastX - startX;
        var flingBoost = velocity * 180;
        var effectiveDelta = delta + flingBoost;

        var blocksMoved = Math.round(-effectiveDelta / cardWidth);
        if (blocksMoved === 0) {
          slideTo(index, true, 0.4);
        } else {
          goTo(index + blocksMoved, 0.4); // スワイプ着地: 0.4秒で軽快に
        }

        startAutoplay();
      });
    }

    function setupMobile() {
      if (list.dataset.looped === 'true') return;
      list.dataset.looped = 'true';

      [1, 2].forEach(function () {
        originalItems.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.removeAttribute('id');
          clone.dataset.clone = 'true';
          list.appendChild(clone);
        });
      });

      index = N;
      baseOffset = list.children[0].offsetLeft;
      cardWidth = list.children[1].offsetLeft - list.children[0].offsetLeft;
      slideTo(index, false);

      startAutoplay();
      addSwipeHandlers();
    }

    function teardownMobile() {
      if (list.dataset.looped !== 'true') return;
      list.dataset.looped = 'false';
      stopAutoplay();
      Array.from(list.querySelectorAll('[data-clone="true"]')).forEach(function (c) {
        c.remove();
      });
      list.style.transition = 'none';
      list.style.transform = 'none';
    }

    function handleChange(e) {
      if (e.matches) setupMobile();
      else teardownMobile();
    }

    if (mq.matches) setupMobile();
    mq.addEventListener('change', handleChange);
  });
});


document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('#Slider-template--21030276726939__slideshow_wfh4Xr');
  if (!container) return;

  var slides = Array.from(container.children).filter(function (el) {
    return el.classList.contains('slideshow__slide');
  });
  if (slides.length < 2) return;

  // Liquidが選んだ画像(fetchpriority="high"が付いている画像)を1番目に固定し、残りをランダムにシャッフル
  var initialIndex = parseInt(container.dataset.initialIndex, 10) || 0;
  var order = slides.map(function (_, i) { return i; }).filter(function (i) {
    return i !== initialIndex;
  });
  for (var i = order.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = order[i]; order[i] = order[j]; order[j] = tmp;
  }
  order.unshift(initialIndex);

  // 初期状態:全部非表示にしてから1枚目だけ表示
  slides.forEach(function (slide) {
    slide.classList.remove('is-active');
    slide.setAttribute('aria-hidden', 'true');
  });

  var current = 0;
  var DISPLAY_DURATION = 5000; // 1枚あたりの表示時間(ms)

  function preloadNext(idx) {
    var nextIdx = (idx + 1) % order.length;
    var img = slides[order[nextIdx]].querySelector('img');
    if (img && img.loading === 'lazy') {
      img.loading = 'eager';
    }
  }

  function showSlide(idx) {
    var slide = slides[order[idx]];
    slide.classList.add('is-active');
    slide.classList.add('is-zoomed');
    slide.setAttribute('aria-hidden', 'false');
    preloadNext(idx);
  }

  function hideSlide(idx) {
    var slide = slides[order[idx]];
    slide.classList.remove('is-active');
    slide.setAttribute('aria-hidden', 'true');
    setTimeout(function () {
      slide.classList.remove('is-zoomed');
    }, 1800);
  }

  showSlide(current);

  setInterval(function () {
    var prev = current;
    current = (current + 1) % order.length;
    showSlide(current);
    hideSlide(prev);
  }, DISPLAY_DURATION);
});